module.exports = __webpack_public_path__ + "static/media/successFace.06c08a35.svg";